export default __webpack_public_path__ + "static/media/onboarding1.b4d77e94.png";